module.exports = __webpack_public_path__ + "static/media/ATMA-SPHERE UV-1 ULTRAVIOLET PRE AMPLIFIER.12e9ab13.png";